import { ImageUploaderTemplate } from "./template";
import { useImageUploader } from "./logic";

export const ImageUploader = (): JSX.Element => {
  const props = useImageUploader();

  return <ImageUploaderTemplate {...props} />;
};
